const resolveVariable = ({ varName, definition, computedValue, assignVariable }) => {
  const { outputModes, defaultValue, colorVarEnding, opacityVarEnding } = definition;
  const result = {};

  if (outputModes.includes('string')) {
    result[varName] = computedValue != null ? String(computedValue) : defaultValue;
  }

  if (outputModes.includes('color') && computedValue != null) {
    result[`${varName}${colorVarEnding}`] = assignVariable(computedValue);
  }

  if (outputModes.includes('opacity') && typeof computedValue?.getAlpha === 'function') {
    result[`${varName}${opacityVarEnding}`] = String(computedValue.getAlpha());
  }

  return result;
};

export default resolveVariable;
